import { Injectable } from '@angular/core';
import { AppStatus, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { take } from 'rxjs/operators';
import { ModalManagementService, ModalSize } from '@wdx/clmi/ui';
import { AddDocumentRequirementModalComponent } from '../../../../../../shared/features/documents/add-document-requirement-modal/add-document-requirement-modal.component';
import { DocumentPreviewComponent } from '../../../../../../shared/features/documents/document-preview/document-preview.component';
import {
    GenerateDocumentTemplateItem,
    GenerateDocumentTemplateModalComponent,
} from '../../../../../../shared/features/documents/generate-document-template-modal';
import { DocumentPreviewParams } from './documents-modal.model';
import { Regarding } from '@wdx/shared/utils';

@Injectable({
    providedIn: 'root',
})
export class DocumentsModalService {
    constructor(private modalManagementService: ModalManagementService) {}

    openPreviewModal(params: DocumentPreviewParams): void {
        const modal = this.modalManagementService.openModalWithComponent(
            DocumentPreviewComponent,
            {
                size: ModalSize.Xl,
            },
        );
        modal.componentInstance.title = params.title;
        modal.componentInstance.useModal = true;
        modal.componentInstance.sourceType = params.sourceType;
        modal.componentInstance.activeDocument = params.activeDocument;
        modal.componentInstance.entityId = params.entityId;
        modal.componentInstance.entityType = params.entityType;
        modal.componentInstance.mode = params.mode;
        modal.componentInstance.documents = params.documents;
        modal.componentInstance.linkedIds = params.linkedIds;
        modal.componentInstance.linkToId = params.linkToId;
        modal.componentInstance.permittedTypes = params.permittedTypes;
        modal.componentInstance.initialIndex = params.initialIndex;
        modal.componentInstance.hideCloseModal = params.hideCloseModal;
        modal.componentInstance.hideFileList = params.hideFileList;
        modal.componentInstance.queryEntity = params.queryEntity;
    }

    openGenerateDocumentTemplatesModal(
        items: GenerateDocumentTemplateItem[],
    ): void {
        const modal = this.modalManagementService.openModalWithComponent(
            GenerateDocumentTemplateModalComponent,
            {
                size: ModalSize.Md,
            },
        );

        modal.componentInstance.items = items;

        modal.componentInstance.documentGenerated
            .pipe(take(1))
            .subscribe(() => {
                modal.dismiss();
            });

        modal.componentInstance.cancelled.pipe(take(1)).subscribe(() => {
            modal.dismiss();
        });

        modal.componentInstance.submitted.pipe(take(1)).subscribe(() => {
            modal.dismiss();
        });
    }

    openAddDocumentRequirementModal(
        caseId: string,
        entityId: string,
        systemEntity: SystemEntity,
        app: AppStatus,
        regarding?: Regarding[],
        includeCaseEntity = false,
    ): void {
        const modal = this.modalManagementService.openModalWithComponent(
            AddDocumentRequirementModalComponent,
            {
                size: ModalSize.Md,
            },
        );
        const component =
            modal.componentInstance as AddDocumentRequirementModalComponent;
        component.caseId = caseId;
        component.entityId = entityId;
        component.regarding = regarding;
        component.systemEntity = systemEntity;
        component.app = app;
        component.includeCaseEntity = includeCaseEntity;
        component.documentTypeAdded?.pipe(take(1)).subscribe(() => {
            modal.dismiss();
        });
        component.cancelled?.pipe(take(1)).subscribe(() => {
            modal.dismiss();
        });
    }
}
